import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface SongBasicFieldsProps {
  tittel: string;
  artist: string;
  album: string;
  onTittelChange: (value: string) => void;
  onArtistChange: (value: string) => void;
  onAlbumChange: (value: string) => void;
}

export const SongBasicFields: React.FC<SongBasicFieldsProps> = ({
  tittel,
  artist,
  album,
  onTittelChange,
  onArtistChange,
  onAlbumChange,
}) => {
  return (
    <>
      {/* Tittel */}
      <div className="space-y-2">
        <Label htmlFor="title">
          Tittel <span className="text-destructive">*</span>
        </Label>
        <Input
          id="title"
          placeholder="Skriv inn sangtittel"
          value={tittel}
          onChange={(e) => onTittelChange(e.target.value)}
          className="bg-slate-50/50 focus:bg-white"
          autoFocus
        />
      </div>

      {/* Artist og Album */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="artist">
            Artist <span className="text-destructive">*</span>
          </Label>
          <Input
            id="artist"
            placeholder="Skriv inn artist"
            value={artist}
            onChange={(e) => onArtistChange(e.target.value)}
            className="bg-slate-50/50 focus:bg-white"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="album">Album</Label>
          <Input
            id="album"
            placeholder="Skriv inn album"
            value={album}
            onChange={(e) => onAlbumChange(e.target.value)}
            className="bg-slate-50/50 focus:bg-white"
          />
        </div>
      </div>
    </>
  );
};

